import React, { useEffect, useCallback } from 'react'
import { useSelector, useDispatch, useStore } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import SidebarItems from '../lists/SidebarItems'
import { itemIdsToItems } from '../item/itemsTransformers'
import { fetchPopular } from '../item/popularActions'

/** We can't claim item is popular if it doesn't have at least some clicks */
export const MIN_POPULAR_CLICKS = 25


const SidebarPopular = ({ category, tag }) => {
  const dispatch = useDispatch()
  const itemIds = useSelector(state => state.popular.get('itemIds'))
  const loading = useSelector(state => state.popular.get('loading'))
  const shouldUpdate = useSelector(state => state.popular.get('shouldUpdate'))
  const failedToLoad = useSelector(state => state.popular.get('failedToLoad'))

  // Using store.getState() to avoid re-rendering on every tiny change in the state
  const state = useStore().getState()
  const items = itemIdsToItems(state, itemIds)

  const dispatchRefresh = useCallback((force = false) => {
    if (window.document.hidden) return

    const cacheTTL = category || tag ? 900 : 300
    const categoryId = category?.id
    const tagId = tag?.id

    dispatch(fetchPopular(force ? 0 : cacheTTL, { categoryId, tagId }))
  }, [dispatch, category, tag])

  useEffect(() => {
    if (shouldUpdate) {
      // Trigger fetch after changes to profile (eg. blacklisted something)
      dispatchRefresh(true)
    }
  }, [shouldUpdate, dispatchRefresh])

  useEffect(() => {
    const interval = setInterval(dispatchRefresh, 5000)
    return () => clearInterval(interval)
  }, [dispatchRefresh])

  if (items.size < 5 || items.last().get('clicks', 0) < MIN_POPULAR_CLICKS) {
    return null
  }

  let title = 'Luetuimpia'
  if (category) {
    title = 'Luetuimpia: ' + category.get('name')
  }
  if (tag) {
    title = 'Luetuimpia: #' + tag.get('name')
  }

  return (
    <SidebarItems
      title={ title }
      linkTo='/luetuimmat'
      linkToTitle='Näytä luetuimmat uutiset'
      className='popular'
      dispatch={ dispatch }
      loading={ loading }
      failedToLoad={ failedToLoad }
      items={ items }
      emptyText=''
    />
  )
}

SidebarPopular.propTypes = exact({
  category: ImmutablePropTypes.record,
  tag: ImmutablePropTypes.record,
})

export default SidebarPopular
